module.exports = __webpack_public_path__ + "media/images/athletes/3419-96e58393273d9dc85cf6a35ecdfc24b7.png";